import { Group } from './Group'

export type IPositionData = {
    Faggruppe: {
        Sektor: {
            Kode: string
            Navn: string
        }
        Nummer: number
        Navn: string
    }
    Navn: string
    Nummer: number
    Arbejdsstedsnumre: number[]
}

export class Position {
    id = 0

    name = ''

    group: Group = new Group()

    number: number

    numbers: number[] = []

    static build(data: IPositionData): Position {
        const department = new Position()

        department.id = data.Nummer
        department.name = data.Navn
        department.group = Group.build(data.Faggruppe)
        department.number = data.Nummer
        department.numbers = data.Arbejdsstedsnumre

        return department
    }
}

export function mapPositions(data: IPositionData[]): Position[] {
    return data.map((position) => Position.build(position))
}
